import { createStore } from "ui.vue3.vuex";

export const store = createStore({
  state() {
    return { params: {} };
  },
  mutations: {
    setGlobalParams(state, payload) {
      state.params = payload;
    },
  },
  actions: {
    setGlobalParams(context, payload) {
      context.commit("setGlobalParams", payload);
    },
  },
});
